import apiClient from './apiClient';

const bonusClient = apiClient('bonus');

const bonusApi = {
    /** Список бонусных промо текущего пользователя (созданных как 1st time free) */
    async getMyBonusPromos() {
        const res = await bonusClient.get('/promos');
        return res.data || [];
    },

    /** Проверка: доступен ли бонус (ещё не использован) */
    async checkMy() {
        const res = await bonusClient.get('/check');
        return res.data;
    },

    /** Валидация параметров бонусного промо */
    async validate(data) {
        const res = await bonusClient.post('/validate', data);
        return res.data;
    },

    /**
     * Создать бонусное промо (полный flow).
     * @param {Object} data - данные для создания
     * @param {number} data.categoryId - ID категории кристалла
     * @param {number} data.participantsCount - количество участников
     * @param {number} data.prizePlacesCount - количество призовых мест
     * @param {string} data.link - ссылка на Telegram
     * @param {Array} data.promoters - промоутеры
     * @param {number} data.durationDays - длительность (дни)
     * @param {Array} data.tasks - задачи
     * @param {Object} data.category - данные категории (positions)
     */
    async createBonusPromo(data) {
        const res = await bonusClient.post('/create-promo', data);
        return res.data;
    },
};

export default bonusApi;
